export const layout= {
  breakpoint: {
    sm: '600px',
    lg: '780px',
    xl: '980px',
    xxl: '1280px',
  }
};
